import React, { forwardRef } from 'react';
import './Input.css';

export const Input = forwardRef(({
  type = 'text',
  style = 'outline',
  value = '',
  placeholder = '',
  label,
  labelClassName = '',
  labelTooltip = '',
  /** Inside the field, flush after the value (e.g. ":1" for WCAG), placeholder tone */
  fieldSuffix = null,
  onChange,
  onFocus,
  onBlur,
  onKeyDown,
  disabled = false,
  className = '',
  ...props
}, ref) => {
  const baseClass = 'input';
  const styleClass = `input--${style}`;
  const disabledClass = disabled ? 'input--disabled' : '';

  const inputCoreClassName = [
    baseClass,
    styleClass,
    disabledClass,
  ].filter(Boolean).join(' ');

  const combinedClassName = [
    inputCoreClassName,
    className,
  ].filter(Boolean).join(' ');

  const suffixRowClassName = [
    'input__field-row',
    'input__field-row--inline-suffix',
    disabled ? 'input__field-row--disabled' : '',
    className,
  ].filter(Boolean).join(' ');

  // Determine input type
  const inputType = type === 'number' ? 'number' : 'text';

  return (
    <div className="input-wrapper">
      {label && (
        <label 
          className={`input__label ${labelTooltip ? 'tooltip' : ''} ${labelClassName}`} 
          tabIndex={-1}
          data-tooltip={labelTooltip || undefined}
        >
          {label}
        </label>
      )}
      {fieldSuffix ? (
        <div className={suffixRowClassName}>
          <input
            ref={ref}
            type={inputType}
            value={value}
            placeholder={placeholder}
            onChange={onChange}
            onFocus={onFocus}
            onBlur={onBlur}
            onKeyDown={onKeyDown}
            disabled={disabled}
            className={inputCoreClassName}
            {...props}
          />
          <span className="input__field-suffix" aria-hidden="true">{fieldSuffix}</span>
        </div>
      ) : (
        <input
          ref={ref}
          type={inputType}
          value={value}
          placeholder={placeholder}
          onChange={onChange}
          onFocus={onFocus}
          onBlur={onBlur}
          onKeyDown={onKeyDown}
          disabled={disabled}
          className={combinedClassName}
          {...props}
        />
      )}
    </div>
  );
});

Input.displayName = 'Input';
